import { DateAdapter } from '@angular/material/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from './../../../environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { BixAlertService } from '../components/bix-alert/bix-alert.service';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  apiUrl = environment.apiUrl;
  endpoint = "";
  customerId;
  customerDetail;
  constructor(
    private http: HttpClient,
    private router: Router,
    private _snackBar: MatSnackBar,
    private dateAdapter:DateAdapter<Date>,
    private _alert: BixAlertService
  ) { }
  
  get() {
    return this.http.get(this.apiUrl + this.endpoint);
  }
  getByParams(params: any) {
    return this.http.get(this.apiUrl + this.endpoint, { params: params });
  }

  post(data, endpoint: any = null) {
    return this.http.post(this.apiUrl + (endpoint ?? this.endpoint), data);
  }

  put(data) {
    return this.http.post(this.apiUrl + this.endpoint, data);
  }

  delete() {
    return this.http.delete(this.apiUrl + this.endpoint);
  }

  deleteWithParams(payload?) {
    return this.http.delete(this.apiUrl + this.endpoint, { params: payload });
  }

  getDocsWithHeaders() {
    return this.http.get(this.endpoint, 
      { 
        observe: 'response',
        responseType: 'blob',
        headers: {
          'Accept': 'application/*'
        }
      });
  }

  getFormData(params: any) {

    return this.http.get(this.apiUrl + this.endpoint, {
      params: params, 
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf'
      }
    });
  }

  notNull(value) {
    return value != "" && value != null && value != undefined;
  }
  deocodeToken(token) {
    if (this.notNull(token)) {
      const helper = new JwtHelperService();
      let decoded = helper.decodeToken(token);
      if (helper.isTokenExpired(token)) {
        this.router.navigateByUrl('/');
        return;
      }
      //user_id, roles
      return decoded;

    } else {
      this.router.navigateByUrl('/');
      return;
    }
  }

  handleApiError(form: FormGroup, error) {
    if (error && error.hasOwnProperty('errors')) {
      Object.keys(error.errors).forEach(key => {
        let err = error.errors[key];
        let formControl = form.get(key);
        if (formControl) {
          if (formControl instanceof FormControl) {
            formControl.setErrors({ invalid: err[0] })
          }
        }
      })
    }
  }
  // handleApiErrorInToaster(error) {
  //   if(error && error.hasOwnProperty('errors')) {
  //     this.openSnackBar(error.errors[Object.keys(error.errors)[0]], 'X','danger')
  //   }
  // }
  // openSnackBar(message: string, action: string, panelClass="info"){
  //   this._snackBar.open(message, action, {
  //     duration: 10000,
  //     horizontalPosition : 'right',
  //     panelClass: [panelClass],
  //   });
  // }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getCurrentCustomerId(baseUrl, callback = (data) => { }) {  
    let url = baseUrl.split("customer-portal");
    let customerId;
    if (url.length == 2) {
      let id = ((url[1].split('/'))[1]);
      customerId = id;
    } else {
      customerId = "";
    }
      this.customerId = customerId;
      this.getCurrentCustomerDetails(callback);
    return this.customerId;
  }

  getCurrentCustomerDetails(callback = (data) => { }) {
    if(this.customerId != null && this.customerId != '') {
      this.endpoint = "customer/" + this.customerId;
      this.get().subscribe(({ data }: any) => {
        this.customerDetail = data;
        callback(this.customerDetail)
      })
    }
  }

  formatDate(date, f = 'y') {
    if (!date) return "";

    var d = moment(date);

    if (f = 'y') {
      return d.format('YYYY-MM-DD');
    } else {
      return d.format('MM-DD-YYYY');
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    if (i > 1) {
      let sizeMax = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    }

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  maxFileSizeValidator(bytes, decimals: number = 2, maxSize: number = 2) {

    if (bytes === 0) return true;

    const dm = decimals <= 0 ? 0 : decimals;
    const bytesInMb = (bytes * 0.000001) / 1;

    if (parseFloat((bytesInMb).toFixed(dm)) > maxSize) {
      this._alert.error('Error', `Upload file max limit is ${maxSize} MB`);
      return false;
    }

    return true;
  }


}
